import { IconButton } from "@material-ui/core";
import React, { memo } from "react";
import { ReactComponent as EditIcon } from "../../../Assets/Images/edit.svg";
import { ReactComponent as ViewIcon } from "../../../Assets/Images/view.svg";
import textStyle from "../../../style/typography";
import PrimaryButton from "../Buttons/PrimaryButton";
import { StyledCard, StyledCardContent } from "../Card";

const CustomCard = ({
  children,
  title,
  mt,
  key,
  hasActionBtn,
  actionBtnTitle,
  onAction,
  editing,
  hasSecondaryBtn,
  secondaryBtnTitle,
  onSecondaryAction,
  isModal,
  formMode,
  setFormMode,
  hasFormMode,
  customStyle,
  hasIcon,
  icon,
  customContentStyle,
  hideActionIcon,
}) => {
  const textClasses = textStyle();

  return (
    <StyledCard
      style={{
        marginTop: mt ? "12px" : "0px",
        overflow: "visible",
        backgroundColor: "#fff",
        padding: 0,
        ...customStyle,
      }}
      key={key}
    >
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          borderBottom: "1px solid rgb(195 194 194 / 54%)",
          padding: hasActionBtn ? `5px 10px` : `14px 10px`,
        }}
      >
        <p className={`${textClasses.header2}  ${textClasses.semibold}`}>
          {title ?? `~`}
        </p>
        <div>
          {hasIcon && <>{icon}</>}
          {hasSecondaryBtn && (
            <PrimaryButton
              hideIcon={true}
              onClick={onSecondaryAction}
              style={{ marginRight: hasActionBtn ? 6 : 0 }}
            >
              {secondaryBtnTitle}
            </PrimaryButton>
          )}
          {!editing && (
            <>
              {hasActionBtn && (
                <PrimaryButton
                  onClick={onAction}
                  hideIcon={hideActionIcon === true}
                >
                  {actionBtnTitle}
                </PrimaryButton>
              )}
            </>
          )}
          {hasFormMode && (
            <>
              {!formMode ? (
                <IconButton
                  onClick={() => setFormMode(!formMode)}
                  style={{ padding: 0 }}
                >
                  <EditIcon />
                </IconButton>
              ) : (
                <IconButton
                  onClick={() => setFormMode(!formMode)}
                  style={{ padding: 0 }}
                >
                  <ViewIcon />
                </IconButton>
              )}
            </>
          )}
        </div>
      </div>

      <StyledCardContent style={customContentStyle ? customContentStyle : {}}>
        {children}
      </StyledCardContent>
    </StyledCard>
  );
};

export default memo(CustomCard);
